<nav class="head-nav">
  <div class="nav-container">
    <div>
      <h2>{{'restaurant.Ingredients Units Configuration' | translate}}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="restaurantId">
          <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="!isProfile">{{"stockManagement.Stock Management" | translate}}</li>
        <li class="breadcrumb-item">{{ "restaurant.Ingredients Units Configuration" | translate }}</li>
    </ol>
    </div>
    <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData()"></app-restaurants-dropdown>
  </div>
</nav>

<div *ngIf='loading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf='!loading'>
  <form class="form-page" [formGroup]="formGroup" (submit)="saveRecord()">
    <div class="form-content wide-content">
      <div class="sticky-head row top-buttons mt-5 mb-3">
        <div class="col-md-6">
          <button mat-button type="button" class="cancel" (click)="openConfirmDialog()">{{'forms.Cancel' | translate}}</button>
        </div>
        <div class="col-md-6 ml-auto">
          <button mat-button class="continue" *ngIf="resultData?.canAdd">{{'forms.Save' | translate}}</button>
        </div>
      </div>
      <br>
      <div class="form-page">
        <div class="form-content outside-title wide-content">
          <div class="card">
            <div class="card-head">
              <div class="row">
                <div class="col-12 mt-3">
                  <div class="info">{{'restaurant.Menu units are the measuring units used to determine the quantity of ingredients while they are included in menu items.' | translate}}</div>
                </div>
                <div class="col-12 mt-3">
                  <div class="info">{{'restaurant.You cannot edit any measurement unit of any ingredient in case its already included in any menu item.' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="card-content pt-0">

              <div class="table-responsive mt-3" *ngIf="resultData?.restaurantIngredientDtos?.length; else dataEmpty">
                <table class="table-list ingredient-table" *ngIf="resultData && resultData.restaurantIngredientDtos">
                  <thead>
                    <th width="40%">{{"restaurant.Ingredient Name" | translate}}</th>
                    <th class="text-left" width="25%">{{"warehouse.Storage unit" | translate}}</th>
                    <th class="text-left" width="35%">{{"content2.Price" | translate}}</th>
                    <th></th>
                  </thead>
                  <tbody formArrayName="ingredients">

                    <tr *ngFor="let ingredient of ingrFormArray.controls; index as i" [formGroupName]="i">
                      <td>
                        <mat-form-field class="ng-select-field" [class.loading-field]="checkLoading == getIngrCtr(i, 'id').value+'_unit'">
                          <ng-select class="pb-0 ingredient-select" ngSelectMat
                            appearance="outline" appendTo="body" [items]="allIngredients" [virtualScroll]="true"
                            bindLabel="name" bindValue="id" [notFoundText]='"general.No Data Found" | translate'
                            [loadingText]='"general.Loading..." | translate' (search)="dropIngredientSearch($event)"
                            (clear)="dropIngredientSearch($event)" (blur)="dropIngredientSearch($event)"
                            formControlName="ingredientId" (change)="selectedIngr($event, i); validateDuplicate(i); changeIngredientUnit(i)">
                            <ng-template ng-label-tmp let-item="item">
                              <div class="name-with-image squared p-0">
                                <div class="image-circle">
                                  <span *ngIf="!item.icon">{{ item.name | shortName }}</span>
                                  <img *ngIf="item.icon" [src]="item.icon" (error)="item.icon = ''">
                                </div>
                                <div class="name">
                                    <h5 class="font-16">{{item.name}}</h5>
                                </div>
                              </div>
                              <!-- <img [src]="item.icon"> {{item.name}} -->
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                              <div class="name-with-image squared p-0">
                                <div class="image-circle">
                                    <span *ngIf="!item.icon">{{ item.name | shortName }}</span>
                                    <img *ngIf="item.icon" [src]="item.icon" (error)="item.icon = ''">
                                </div>
                                <div class="name">
                                    <h5 class="font-16">{{item.name}}</h5>
                                </div>
                              </div>
                            </ng-template>
                          </ng-select>
                          <mat-error *ngIf="ingrHasError('ingredientId', i, 'required')">{{ 'forms.Required' | translate }}</mat-error>
                          <mat-error *ngIf="ingrHasError('ingredientId', i, 'duplicated')">{{ 'forms.Duplicated' | translate }}</mat-error>
                        </mat-form-field>
                      </td>
                      <td class="text-right">
                        <mat-form-field class="no-label width-auto w-100" hideRequiredMarker
                          [class.loading-field]="checkLoading == getIngrCtr(i, 'id').value+'_unit'">
                          <mat-select [placeholder]="'warehouse.Storage unit' | translate" (valueChange)="changeIngredientUnit(i)"
                            formControlName="ingredientUnitId" (selectionChange)="validateDuplicate(i)">
                            <mat-option *ngFor="let item of unitsData" [value]="item.id">{{item.name}}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="ingrHasError('ingredientUnitId', i, 'required')">{{ 'forms.Required' | translate }}</mat-error>
                          <mat-error *ngIf="ingrHasError('ingredientUnitId', i, 'duplicated')">{{ 'forms.Duplicated' | translate }}</mat-error>
                        </mat-form-field>
                      </td>
                      <td>
                      <div class="d-flex justify-content-start">
                        <div class="pr-3">
                          <mat-form-field class="no-label" hideRequiredMarker>
                            <mat-select [placeholder]="'warehouse.costPriceMethod' | translate"
                              formControlName="costPriceMethod" (selectionChange)="onChangeCostPriceMethod(i)">
                              <mat-option *ngFor="let method of costPriceMethods" [value]="method.value">
                                {{method.name}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="ingrHasError('costPriceMethod', i, 'required')">{{ 'forms.Required' | translate }}</mat-error>
                          </mat-form-field>
                        </div>
                        <div
                          [hidden]="!ingredient.value.costPriceMethod || ingredient.value.costPriceMethod == 'FromTransactions'">
                          <mat-form-field hideRequiredMarker class="no-label font-16" style="width: 7rem;">
                            <input matInput formControlName="costPrice" [required]="ingredient.value.costPriceMethod == 'Fixed'"
                              [placeholder]="'content2.Price' | translate">
                            <div matSuffix *ngIf="defaultCurrency">{{defaultCurrency.currencyCode}}</div>
                            <mat-error *ngIf="ingrHasError('costPrice', i, 'required')">{{ 'forms.Required' | translate
                              }}</mat-error>
                            <mat-error
                              *ngIf="ingrHasError('costPrice', i, 'pattern') || ingrHasError('costPrice', i, 'max')">
                              {{ 'forms.Invalid value' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      </td>
                      <td class="actions">
                        <div class="card-actions">
                          <mat-spinner class="m-auto" diameter="15"
                            *ngIf="checkLoading == getIngrCtr(i, 'id').value"></mat-spinner>
                          <button mat-icon-button type="button" (click)="removeIngredient(i)">
                            <img src="./assets/images/icons/close.svg">
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-3" *ngIf="resultData?.canAdd">
                <button mat-button type="button" class="btn-light btn-small" mat-stroked-button (click)="addIngr()">
                  <img src="./assets/images/icons/plus-ic.svg">
                  <span>{{"restaurant.Add Ingredients" | translate}}</span>
                </button>
              </div>

            </div>

            <ng-template #dataEmpty>
              <empty-state [title]='"general.No Data Found" | translate'></empty-state>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
